import Hero from "./home/Hero";
import Marquee from "@/components/Marquee";
import ServicesPreview from "./home/ServicesPreview";
import InterventionsBand from "./home/InterventionsBand";
import HowItWorksSection from "./home/HowItWorksSection";
import WhyBrox from "./home/WhyBrox";
import MaterialsSection from "./home/MaterialsSection";
import BusinessBand from "./home/BusinessBand";
import SocialBand from "@/components/SocialBand";
import CtaBand from "./home/CtaBand";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <ServicesPreview />
      <InterventionsBand />
      <HowItWorksSection />
      <WhyBrox />
      <MaterialsSection />
      <BusinessBand />
      <SocialBand />
      <CtaBand />
    </>
  );
}
